<template>
  <div class="action-modal-container" v-if="show" @click.self="$emit('close')">
    <div class="action-modal-wrapper">
      <span class="modal-title">{{ title }}</span>
      <div class="modal-body" v-html="body"></div>
      <div class="modal-buttons">
        <div
          v-for="(button, index) in buttons"
          :key="index"
          :class="['modal-button', button.class]"
          @click="button.action"
        >
          {{ button.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionModal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    body: {
      type: String,
      default: "",
    },
    buttons: {
      type: Array,
      default: () => [], // Example: [{ text: 'OK', class: 'primary', action: () => {} }]
    },
  },
};
</script>

<style scoped>
.action-modal-container {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  display: flex;
  z-index: 9998;
}

.action-modal-wrapper {
  padding: 30px 20px;
  background-color: #25253a;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  width: 90%;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  color: white;
}

.modal-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 20px;
  letter-spacing: 0.4px;
  color: #bb86fc;
}

.modal-body {
  margin: 20px 0;
  text-align: left;
  color: #a5a5ab;
  line-height: 1.6;
  width: 100%;
}

.modal-body >>> strong {
  color: #fff;
  font-weight: 600;
}

.modal-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}

.modal-button {
  margin: 0 10px;
  padding: 12px 20px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1.25px;
  cursor: pointer;
  text-transform: uppercase;
}

.modal-button.primary {
  background-color: #bb86fc;
  color: white;
}

.modal-button.secondary {
  color: #bb86fc;
  border: 1px solid #bb86fc;
}
</style>